import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=0cd2a014&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "./Event.vue?vue&type=style&index=0&id=0cd2a014&prod&scoped=true&lang=css"
import style1 from "./Event.vue?vue&type=style&index=1&id=0cd2a014&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2a014",
  null
  
)

export default component.exports